import React, { lazy }  from 'react'

import { Route, Link } from 'react-router-dom'

import {Input, Button, Menu, ConfigProvider, Drawer, Space, message, Form, Switch, Radio} from 'antd'

import 'moment/locale/zh-cn'

import zhCN from 'antd/es/locale/zh_CN'

import {getStorage, innerHeight, innerWidth, removeStorage, API, isLeader, checkPower} from "../../../utils"

import styles from '../../../assets/css/pc/layout/default.module.scss'

import logo from '../../../assets/images/logo.jpg'

// 导入路由页
const Workbench = lazy(() => import('../workbench'))
const Client = lazy(() => import('../Client'))
const Highseas = lazy(() => import('../Client/highseas'))
const Visitplane = lazy(() => import('../Client/visitplane'))
const Score = lazy(() => import('../Score'))
const ScoreStatistics = lazy(() => import('../Score/statistics'))
const Record = lazy(() => import('../Record'))
const Call = lazy(() => import('../Record/call'))
const UserDistribute = lazy(() => import('../User/distribute'))
const UserDataacceplog = lazy(() => import('../User/dataacceplog'))
const StatisticsData = lazy(() => import('../Statistics/data'))
const Achievement = lazy(() => import('../Achievement'))
const AchievementUser = lazy(() => import('../Achievement/user'))
const Cost = lazy(() => import('../Cost'))
const CostRecord = lazy(() => import('../Cost/record'))
const Settlement = lazy(() => import('../Settlement'))
const Channel = lazy(() => import('../Channel'))
const ChannelStatistics = lazy(() => import('../Channel/statistics'))
const Team = lazy(() => import('../Team'))
const UserList = lazy(() => import('../User/list'))
const Option = lazy(() => import('../Option'))
const School = lazy(() => import('../School'))
const Outbound = lazy(() => import('../Outbound'))
const ChannelIntervalStatistics = lazy(() => import('../Channel/intervalStatistics'))
const StatisticsRegion = lazy(() => import('../Statistics/region'))
const StatisticsDistributeInterval = lazy(() => import('../Statistics/distributeInterval'))

export default class Index extends React.PureComponent {
    state = {
        selectedTab: this.props.location.pathname,
        right: [],
        selectedKeys: 0,
        openKeys: 0,
        mainContentWidth: 0,
        mainContentMinWidth: 0,
        mainContentHeight: 0,
        mainContentMinHeight: 0,
        userDrawer: {
            open: false
        },
        userInfo: {}
    }

    userDrawerFormRes = React.createRef()

    renderUserDrawer = () => {
        let { userDrawer, userInfo } = this.state
        let { open } = userDrawer
        let user = getStorage('user')

        let nickname = user.nickname
        if (isLeader() && userInfo.team.property === 2) {
            nickname += "，余额：" + userInfo.team.money + "，预估余额："+userInfo.team.predict_money
        }

        return (
            <Drawer closable={false} onClose={ () => {this.setState({userDrawer: {open: false}})} } title={ nickname }  width={ 750 } open={ open } bodyStyle={{ padding: '0 20px'}} extra={
                <Space>
                    {
                        checkPower('/team/changedistmode') ?
                            <Radio.Group defaultValue={ userInfo.dist_mode } buttonStyle="solid" onChange={async ({ target: { value } }) => {
                                try {
                                    await API.get('/team/changedistmode', {
                                        params: {
                                            'team_id': userInfo.team.id,
                                            'dist_mode': value,
                                        }
                                    })
                                    window.location.reload()
                                } catch (e){}
                            }}>
                                <Radio value="system">系统派发</Radio>
                                <Radio value="liberty">自主派发</Radio>
                            </Radio.Group> : <></>
                    }

                    <Switch defaultChecked={userInfo.in_three === 1} checkedChildren="接收数据" unCheckedChildren="关闭数据" onChange={async () => {
                        await API.get('/user/dataaccep', {
                            params: {
                                'field': 'in_three',
                                'value': (userInfo.in_three === 1 ? 0 : 1)
                            }
                        })

                        window.location.reload()
                    }} />
                </Space>
            }>
                <div>
                    <Form layout='vertical' ref={ this.userDrawerFormRes } onFinish={async (values) => {
                        try {
                            await API.post('/user/changepwd', values)

                            removeStorage('right_menu')
                            removeStorage('power')
                            removeStorage('left_menu')
                            removeStorage('limit')
                            removeStorage('user')

                            this.props.history.replace('/login')
                        } catch (e) {}
                    }}>
                        <Form.Item name='oldpassword' label='旧密码：' rules={[{ required: true, message: '请输入旧密码!' }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name='newpassword' label='新密码：' rules={[{ required: true, message: '请输入新密码!' }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name='renewpassword' label='确认新密码：' rules={[{ required: true, message: '请确认新密码!' }]}>
                            <Input />
                        </Form.Item>

                        <Space>
                            <Button type="primary" onClick={ () => {
                                message.success('正在退出', 1, () => {
                                    removeStorage('right_menu')
                                    removeStorage('power')
                                    removeStorage('left_menu')
                                    removeStorage('limit')
                                    removeStorage('user')

                                    this.props.history.replace('/login')

                                })
                            } }>退出登录</Button>

                            <Button type="primary" onClick={ () => { this.userDrawerFormRes.current.submit() } }>密码修改</Button>
                        </Space>
                    </Form>
                </div>
            </Drawer>
        )
    }

    /**
     * 渲染左侧菜单
     * @returns {JSX.Element}
     */
    renderLeftMenu = () => {
        // 用户信息
        let user = getStorage('user')

        // 左侧菜单
        let left = getStorage('left_menu')

        let { selectedTab } = this.state

        return (
            <nav className={ styles.layout_left }>
                <img className={ `${styles.layout_left_avatar} hand` } onClick={ async () => {
                    let userInfo = await API.get('/user/userinfo')
                    this.setState({
                        userInfo
                    }, () => {
                        this.setState({
                            userDrawer: {
                                open: true
                            }
                        })
                    })
                }} src={ user.avatar } alt={ user.nickname } title={ user.nickname } />

                <div className={ styles.layout_left_menu }>
                    {left.map((item, key) =>
                        <Link to={ item.route } className={ `${styles.layout_left_menu_item} ${ selectedTab ===  item.route ? styles.layout_left_menu_active : '' }` } key={ key }>
                            <i className={ item.icon } />
                            <span className={ styles.layout_left_menu_item_title }>{ item.label }</span>
                        </Link>
                    )}
                </div>

                <img className={ styles.layout_left_logo } src={ logo } alt="" />
            </nav>
        )
    }

    /**
     * 渲染右侧 header
     * @returns {JSX.Element}
     */
    renderRightHeader = () => {
        return (
            <header className={ styles.layout_right_header }>
                <div className={ styles.layout_right_header_right }>
                    <Input.Search allowClear placeholder="客户姓名/编号/联系方式等" />

                    <Button type="default">
                        <i className="crm-iconfont crm-icon-tianjiakehu" />
                        新增客户
                    </Button>

                    <Button type="default">
                        <i className="crm-iconfont crm-icon-tianjiajilu" />
                        添加跟进记录
                    </Button>

                    <i className="crm-iconfont crm-icon-gengduo" />
                </div>

                <div className={ styles.layout_right_header_left }>
                    <i className="crm-iconfont crm-icon-tongzhi" title="通知中心" />
                    <i className="crm-iconfont crm-icon-bangzhuzhongxin" title="帮助中心" />
                </div>
            </header>
        )
    }

    /**
     * 渲染右侧子菜单
     * @returns {JSX.Element}
     */
    renderRightMenu = () => {
        let { right, selectedKeys, openKeys } = this.state
        let rightMenu = <div></div>
        if (right.length !== 0) {
            rightMenu = <nav className={ `${styles.layout_right_main_menu} ${right.length === 0 ? 'hidden' : ''}`}>
                <Menu theme={ "light" } forceSubMenuRender={ true } selectedKeys={ [''+selectedKeys+''] } openKeys={ [''+openKeys+''] } mode="inline" items={ right }
                      onSelect={({ item, key, keyPath, selectedKeys, domEvent }) => { this.props.history.push(`${item.props.route}`) }}
                      onOpenChange={this.openChange}
                />
            </nav>
        }
        return rightMenu
    }

    render() {
        return (
            <ConfigProvider locale={zhCN}>
                <div className={ styles.layout }>
                    { /*渲染左侧菜单*/ }
                    { this.renderLeftMenu() }

                    <div className={styles.layout_right}>
                        {/* 渲染右侧 header */}
                        { this.renderRightHeader() }

                        <div className={ styles.layout_right_main }>
                            {/* 渲染右侧菜单 */}
                            { this.renderRightMenu() }

                            <div className={ styles.layout_right_main_content } style={{ width: this.state.mainContentWidth, minWidth:this.state.mainContentMinWidth }} >
                                {/* 子路由匹配规则 */}
                                <Route exact path="/home/workbench" component={ Workbench } />
                                <Route exact path="/home/client" component={ Client } />
                                <Route exact path="/home/client/:number" component={ Client } />
                                <Route exact path="/home/clientHighseas" component={ Highseas } />
                                <Route exact path="/home/clientVisitplane" component={ Visitplane } />
                                <Route exact path="/home/score" component={ Score } />
                                <Route exact path="/home/scoreStatistics" component={ ScoreStatistics } />
                                <Route exact path="/home/record" component={ Record } />
                                <Route exact path="/home/call" component={ Call } />
                                <Route exact path="/home/userDistribute" component={ UserDistribute } />
                                <Route exact path="/home/userDataacceplog" component={ UserDataacceplog } />
                                <Route exact path="/home/statisticsData" component={ StatisticsData } />
                                <Route exact path="/home/achievement" component={ Achievement } />
                                <Route exact path="/home/achievementUser" component={ AchievementUser } />
                                <Route exact path="/home/cost" component={ Cost } />
                                <Route exact path="/home/costRecord" component={ CostRecord } />
                                <Route exact path="/home/settlement" component={ Settlement } />
                                <Route exact path="/home/channel" component={ Channel } />
                                <Route exact path="/home/channelStatistics" component={ ChannelStatistics } />
                                <Route exact path="/home/team" component={ Team } />
                                <Route exact path="/home/userList" component={ UserList } />
                                <Route exact path="/home/option" component={ Option } />
                                <Route exact path="/home/school" component={ School } />
                                <Route exact path="/home/outbound" component={ Outbound } />
                                <Route exact path="/home/channelIntervalStatistics" component={ ChannelIntervalStatistics } />
                                <Route exact path="/home/statisticsRegion" component={ StatisticsRegion } />
                                <Route exact path="/home/statisticsDistributeInterval" component={ StatisticsDistributeInterval } />
                            </div>
                        </div>
                    </div>

                    { this.state.userDrawer.open ? this.renderUserDrawer() : <></> }
                </div>
            </ConfigProvider>
        )
    }

    openChange = (data) => {
        let openKeys = data.length !== 0 ? data[1] : 0
        this.setState({
            openKeys
        })
    }

    initRightMenu = () => {
        // left：左侧菜单，right：右侧菜单
        let left = getStorage('left_menu'), right = getStorage('right_menu')
        // 获取当前浏览器的路由，如：/home/workbench
        let pathname = this.props.location.pathname

        /**
         * 根据当前浏览器路由获取右侧菜单
         */
        let now // 当前菜单
        right.some((item) => {
            // 判断右侧所有子菜单的路由是否和当前浏览器的路由相同
            now = item.children.filter(item => pathname === item.route)
            if (now.length !== 0) {
                return true
            } else {
                return false
            }
        })
        if (now.length !== 0) {
            // 判断当前菜单的 key 是否在左侧某个菜单的 child_id 数组中
            left = left.filter(item => item.child_id.indexOf(now[0].key) !== -1)
            if (left.length !== 0) {
                // 根据左侧菜单 child_id 数组返回右侧菜单
                right = right.filter(item => left[0].child_id.indexOf(item.key) !== -1)
            } else {
                right = []
            }
        } else {
            right = []
        }

        // selectedKeys：选中的子菜单 key，openKeys：选中的父菜单 key
        let selectedKeys, openKeys
        if (right.length !== 0) {
            for (let i=0; i<right.length; i++) {
                let selectMenu = right[i].children.filter(item => item.route === pathname)
                if (selectMenu.length !== 0) {
                    selectedKeys = selectMenu[0].key
                    openKeys = selectMenu[0].p_key
                    break
                }
            }
        }

        this.setState({
            right,
            selectedKeys,
            openKeys,
        }, function () {
            this.setManContentWidthAndHeight()
        })
    }

    setManContentWidthAndHeight = () => {
        // 设置 mainContent 宽度
        let windowWidth = innerWidth()
        let defaultMinWidth = 1450
        let subWidth = this.state.right.length === 0 ? 6 : 6+120
        let mainContentWidth = windowWidth <= defaultMinWidth ? defaultMinWidth - subWidth : windowWidth - subWidth
        let mainContentMinWidth = defaultMinWidth - subWidth

        let widowHeight = innerHeight()
        let mainContentHeight = widowHeight - 52

        this.setState({
            mainContentWidth,
            mainContentMinWidth,
            mainContentHeight,
        })
    }

    /**
     * 生命周期函数
     * 触发时间：组件更新（完成 DOM 渲染）之后
     * 使用场景
     *  1、发送网络请求
     *  2、DMO 操作
     *  3、如果要用 setState()，必须要放在 if 条件中
     *
     * @param prevProps 上一次的 prevProps
     * @param prevState 上一次的 prevState
     * @param snapshot
     */
    componentDidUpdate(prevProps, prevState, snapshot) {
        let pathname = this.props.location.pathname // 当前的路由地址
        let prevPathname = prevProps.location.pathname // 上一次的路由地址

        /**
         * 当前的路由地址 不等于 上一次的路由地址时
         * 更改 selectedTab 值，让对应的菜单项高亮
         */
        if (pathname !== prevPathname) {
            this.setState({
                selectedTab: pathname
            })
            this.initRightMenu()
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.setManContentWidthAndHeight)

        this.setState({
            selectedTab: this.props.location.pathname
        })

        this.initRightMenu()
    }

    /**
     * 生命周期函数
     * 触发时间：组件从页面中消失
     * 使用场景：清理开启的定时器，手动创建的 DOM 对象等
     */
    componentWillUnmount(){
        window.removeEventListener('resize', this.setManContentWidthAndHeight)
    }
}
